import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchArticles = (params = {}) => api.get("/articles", { params }).then((r) => r.data);
export const fetchArticle = (slug) => api.get(`/articles/${slug}`).then((r) => r.data);
export const fetchEpisodes = (params = {}) => api.get("/episodes", { params }).then((r) => r.data);
export const fetchEpisode = (slug) => api.get(`/episodes/${slug}`).then((r) => r.data);
export const fetchStats = () => api.get("/stats").then((r) => r.data);
export const fetchShow = () => api.get("/show").then((r) => r.data);
export const subscribeNewsletter = (data) => api.post("/newsletter/subscribe", data).then((r) => r.data);
export const sendContact = (data) => api.post("/contact", data).then((r) => r.data);
export const mediaKitPdfUrl = `${API}/media-kit/pdf`;

// Admin
const adminHeaders = (token) => ({ headers: { "X-Admin-Token": token } });

export const adminListSubscribers = (token) =>
  api.get("/newsletter/subscribers", adminHeaders(token)).then((r) => r.data);

export const adminPatchStats = (token, patch) =>
  api.patch("/stats", patch, adminHeaders(token)).then((r) => r.data);

export const adminSendBlast = (token, payload) =>
  api.post("/newsletter/blast", payload, adminHeaders(token)).then((r) => r.data);

export const adminCsvUrl = `${API}/newsletter/export.csv`;

export const adminCreateArticle = (token, payload) =>
  api.post("/articles", payload, adminHeaders(token)).then((r) => r.data);

export const adminUpdateArticle = (token, slug, payload) =>
  api.put(`/articles/${slug}`, payload, adminHeaders(token)).then((r) => r.data);

export const adminDeleteArticle = (token, slug) =>
  api.delete(`/articles/${slug}`, adminHeaders(token)).then((r) => r.data);

export const adminUploadImage = (token, file, onProgress) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/uploads/image", fd, {
    headers: { "X-Admin-Token": token, "Content-Type": "multipart/form-data" },
    onUploadProgress: onProgress,
  }).then((r) => r.data);
};

export const adminCreateEpisode = (token, payload) =>
  api.post("/episodes", payload, adminHeaders(token)).then((r) => r.data);

export const adminUpdateEpisode = (token, slug, payload) =>
  api.put(`/episodes/${slug}`, payload, adminHeaders(token)).then((r) => r.data);

export const adminDeleteEpisode = (token, slug) =>
  api.delete(`/episodes/${slug}`, adminHeaders(token)).then((r) => r.data);
